<template>
  <div id="log-crawler">
    <div
      class="menu-bar header-sm-height mb-3"
      data-pages-init="horizontal-menu"
      data-hide-extra-li="4"
    >
      <a
        href="#"
        class="btn-link header-icon toggle-sidebar d-lg-none"
        data-toggle="horizontal-menu"
      >
        <i class="bi bi-x"></i>
      </a>
      <ul class="log-menu-wrapper">
        <li class="log-menu clickable" @click="current_tab = 1">
          <a :class="current_tab == 1 ? 'text-success' : ''"> Activity </a>
        </li>
        <li class="log-menu clickable" @click="current_tab = 2">
          <a :class="current_tab == 2 ? 'text-success' : ''"> Crawler </a>
        </li>
      </ul>
    </div>
    <table class="table table-bordered" id="activity_table">
      <thead>
        <tr v-if="current_tab == 1">
          <th>Jenis Subscribe</th>
          <th width="50%">Periode</th>
          <th>Status</th>
          <th>Diubah</th>
        </tr>
        <tr v-else>
          <th width="3%">No</th>
          <th width="5%">ID</th>
          <th>Crawler</th>
          <th width="50%">Diubah</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
// import loader_component from "@/views/components/loader.vue";
import gp from "@/plugins/generalPlugins.js";
export default {
  name: "modal_log",
  // components: { "loader-component": loader_component },
  props: {
    data: Array,
  },
  data() {
    return {
      current_tab: 1,
      project: this.data[0],
      activity_data: null,
      table: null,
      is_loading: true,
    };
  },
  methods: {
    showDate: function(date_obj) {
      return gp.dateTimeID(date_obj);
    },
    getActivityLogs() {
      this.is_loading = true;
      const api =
        process.env.VUE_APP_API_URL +
        "projects-logs?items=500&id_project=" +
        this.project._id +
        "";
      this.$http
        .get(api)
        .then((res) => {
          this.activity_data = res.data.project_logs;
          this.drawActivityTable();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    drawActivityTable() {
      this.table.clear();
      if (this.current_tab == 1) {
        for (let index in this.activity_data) {
          const subscribe =
            this.activity_data[index].jenis_subscribe == 1
              ? "Media Sosial"
              : this.activity_data[index].jenis_subscribe == 2
              ? "Media Konvensional"
              : "Media Konvensional & Media Sosial";
          const status =
            this.activity_data[index].status == 0
              ? "Stopped"
              : this.activity_data[index].status == 1
              ? "Running"
              : "Trial";
          const newRow = this.table.row.add([
            subscribe,
            this.activity_data[index].periode,
            status,
            this.showDate(this.activity_data[index].timestamp.$date),
          ]);
          if (newRow.node()) {
            newRow.node().id = index;
          }
        }
        this.table.order([[3, "desc"]]).draw();
      } else {
        let idx = 1;
        for (let index in this.project.crawler) {
          let data = "";
          if (index == "twitter") {
            data = this.showDate(this.project.crawler.twitter.last_id.$date);
          } else if (index == "facebook") {
            let fanpage = "";
            let local = "";
            if (this.project.crawler.facebook.last_date) {
              fanpage =
                "Fanpage: " +
                this.showDate(this.project.crawler.facebook.last_date) +
                "<br />";
            }
            if (this.project.crawler.facebook.local_last_date) {
              local =
                "Local: " +
                this.showDate(
                  this.project.crawler.facebook.local_last_date.$date
                );
            }
            data = fanpage + local;
          } else {
            if (this.project.crawler[index].last_date) {
              data = this.showDate(this.project.crawler[index].last_date.$date);
            } else {
              data = "-";
            }
          }
          const newRow = this.table.row.add([
            idx,
            this.project._id,
            index,
            data,
            "atuh",
          ]);
          if (newRow.node()) {
            newRow.node().id = index;
          }
          idx++;
        }
        this.table.order([[0, "asc"]]).draw();
      }
    },
  },
  watch: {
    current_tab() {
      this.drawActivityTable();
    },
  },
  mounted() {
    this.table = $("#activity_table").DataTable();
    this.getActivityLogs();
  },
};
</script>
